import { ComponentType, MessageType } from '../../../types/enum';

export function createSimpleMessage({
  messageId = '',
  text = '',
  messageType = MessageType.VA,
  operatorName = '',
  messageSubType = '',
}): Message {
  const time = new Date();
  return {
    time: time,
    messageId,
    messageType,
    messageSubType,
    operatorName,
    messageComponent: {
      component: ComponentType.DialogMessageComponent,
      componentData: {
        cardText: text,
        isUserMessage: messageType == MessageType.USER,
        timeStamp: time,
      },
    },
  };
}
